"use client";
import { jsxs as t, jsx as l } from "react/jsx-runtime";
const d = ({
  title: e,
  titleId: i,
  desc: n,
  descId: h,
  ...r
}) => /* @__PURE__ */ t(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    width: 24,
    height: 24,
    "aria-labelledby": i,
    "aria-describedby": h,
    ...r,
    children: [
      n ? /* @__PURE__ */ l("desc", { id: h, children: n }) : null,
      e ? /* @__PURE__ */ l("title", { id: i, children: e }) : null,
      /* @__PURE__ */ l("path", { fill: "none", d: "M0 0h24v24H0z" }),
      /* @__PURE__ */ l("path", { d: "M17 12h-3V8h-4v4H7l5 5zm2-9h-4.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H5c-.14 0-.27.01-.4.04-.39.08-.74.28-1.01.55-.18.18-.33.4-.43.64-.1.23-.16.49-.16.77v14c0 .27.06.54.16.78s.25.45.43.64c.27.27.62.47 1.01.55.13.02.26.03.4.03h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m-7-.25c.41 0 .75.34.75.75s-.34.75-.75.75-.75-.34-.75-.75.34-.75.75-.75M19 19H5V5h14z" })
    ]
  }
);
export {
  d as default
};
